"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Imperfections = exports.Uses = exports.Content = exports.ThreadType = exports.Brand = exports.PackSize = exports.ThreadOnSpool = exports.IndustrialWeight = exports.SpoolSize = exports.SellingUnit = void 0;
var SellingUnit;
(function (SellingUnit) {
    SellingUnit["Individual"] = "Individual";
    SellingUnit["Pack"] = "Pack";
})(SellingUnit = exports.SellingUnit || (exports.SellingUnit = {}));
var SpoolSize;
(function (SpoolSize) {
    SpoolSize["Home Sewing"] = "Home Sewing";
    SpoolSize["Serger"] = "Serger";
    SpoolSize["Industrial"] = "Industrial";
    SpoolSize["Skein"] = "Skein";
})(SpoolSize = exports.SpoolSize || (exports.SpoolSize = {}));
var IndustrialWeight;
(function (IndustrialWeight) {
    IndustrialWeight["Light"] = "Light";
    IndustrialWeight["Medium"] = "Medium";
    IndustrialWeight["Heavy"] = "Heavy";
})(IndustrialWeight = exports.IndustrialWeight || (exports.IndustrialWeight = {}));
var ThreadOnSpool;
(function (ThreadOnSpool) {
    ThreadOnSpool["Full"] = "Full";
    ThreadOnSpool["Less Than Full"] = "Less Than Full";
    ThreadOnSpool["Various"] = "Various";
})(ThreadOnSpool = exports.ThreadOnSpool || (exports.ThreadOnSpool = {}));
var PackSize;
(function (PackSize) {
    PackSize["2 Pack"] = "2 Pack";
    PackSize["4 Pack"] = "4 Pack";
})(PackSize = exports.PackSize || (exports.PackSize = {}));
var Brand;
(function (Brand) {
    Brand["Gutermann"] = "Gutermann";
    Brand["Metrosene"] = "Metrosene";
    Brand["Various"] = "Various";
})(Brand = exports.Brand || (exports.Brand = {}));
var ThreadType;
(function (ThreadType) {
    ThreadType["Embroidery"] = "Embroidery";
    ThreadType["Elastic"] = "Elastic";
    ThreadType["Upholstery"] = "Upholstery";
    ThreadType["Metallic"] = "Metallic";
    ThreadType["Invisible"] = "Invisible";
    ThreadType["All Purpose"] = "All Purpose";
    ThreadType["Unknown"] = "Unknown";
    ThreadType["Silk"] = "Silk";
    ThreadType["Wooly Nylon"] = "Wooly Nylon";
    ThreadType["Yarn"] = "Yarn";
    ThreadType["Embroidery Floss"] = "Embroidery Floss";
})(ThreadType = exports.ThreadType || (exports.ThreadType = {}));
var Content;
(function (Content) {
    Content["Polyester"] = "Polyester";
    Content["Cotton"] = "Cotton";
    Content["Nylon"] = "Nylon";
    Content["Silk"] = "Silk";
    Content["Rayon"] = "Rayon";
    Content["Poly/Cotton Blend"] = "Poly/Cotton Blend";
    Content["Elastane"] = "Elastane";
    Content["Poly/Rubber"] = "Poly/Rubber";
    Content["PU"] = "PU";
    Content["Synthetic"] = "Synthetic";
    Content["Poly/Metal foil"] = "Poly/Metal foil";
    Content["Acrylic"] = "Acrylic";
    Content["Wool"] = "Wool";
})(Content = exports.Content || (exports.Content = {}));
var Uses;
(function (Uses) {
    Uses["Home Decor"] = "Home Decor";
    Uses["Accessories"] = "Accessories";
    Uses["Apparel"] = "Apparel";
})(Uses = exports.Uses || (exports.Uses = {}));
var Imperfections;
(function (Imperfections) {
    Imperfections["Old"] = "Old";
    Imperfections["Dusty"] = "Dusty";
    Imperfections["Broken Spool"] = "Broken Spool";
    Imperfections["Discoloured"] = "Discoloured";
    Imperfections["Weak"] = "Weak";
})(Imperfections = exports.Imperfections || (exports.Imperfections = {}));
//# sourceMappingURL=threadAttributes.js.map